import React from 'react';
import {View, StyleSheet} from 'react-native';
import Svg, {Defs, Rect, LinearGradient, Stop} from 'react-native-svg';

const FROM_COLOR = 'rgb(255, 255, 255)';
const TO_COLOR = 'rgb(0,102,84)';

const HMGradient = (props, {children}) => {
    const {color1, color2, x1, x2, y1, y2, style, height, width} = props
    return (
        <View style={style ? style : {flex: 1}}>
            <Svg height={height ? height : "100%"} width={width ? width : "100%"} style={StyleSheet.absoluteFillObject}>
                <Defs>
                    <LinearGradient id="grad" x1={x1 ? x1 : "80%"} y1={y1 ? y1 : "0%"} x2={x2 ? x2 : "48%"}
                                    y2={y2 ? y2 : "0"}>
                        <Stop offset="0" stopColor={color1 ? color1 : FROM_COLOR}/>
                        <Stop offset="1" stopColor={color2 ? color2 : TO_COLOR}/>
                    </LinearGradient>
                </Defs>
                <Rect height={height ? height : "100%"} width={width ? width : "100%"} fill="url(#grad)"/>
            </Svg>
            {children}
        </View>
    );
};

export default HMGradient;
